export default [
  {
    name: 'Wood burning/Multi Fuel/Pellet Stoves',
    imgSrc: '/images/wood_burner_uncropped.jpg',
    imgAltText: 'Wood Burning Image',
    description:
      ''
  },
  {
    name: 'All sizes of open fires',
    imgSrc: '/images/open_fire.webp',
    imgAltText: 'Open fire image',
    description: ''
  },
  {
    name: 'Aga/Rayburns',
    imgSrc: '/images/aga.jpeg',
    imgAltText: 'Aga Image',
    description: ''
  },
  {
    name: 'Birds nest removal',
    imgSrc: '/images/bird_nest.webp',
    imgAltText: 'Birds nest imager',
    description: ''
  },
  {
    name: 'Bird guards supplied & fitted',
    imgSrc: '/images/bird_guard.jpg',
    imgAltText: 'Bird guard fitted image',
    description: ''
  }
]



// WEBPACK FOOTER //
// ./src/lib/services.js